import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Checkbox, IconButton, TextField, CircularProgress, Box, Typography, Tooltip, FormControl, RadioGroup, Radio, FormControlLabel, Button } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Colors } from "../../../Styles/Colors";
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { ImagePaths } from "../../../Utility/ImagePaths";
import { CommonGridToolBarWithFilterText } from "../../../Components/Common Components/CommonComponents";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { AmountFormat, CheckAccessFunc } from "../../../Components/CommonFunctions/CommonFunctions";
import { CurrencySymbol } from "../../../Utility/Constants";

function StoreCreditNote() {
    const history = useHistory();
    const location = useLocation();
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [isloader, setisloader] = useState(false);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [creditNoteData, setcreidtNoteData] = useState([])
    const [disableBtn, setDisbleBtn] = useState(false);
    const EditAccess = CheckAccessFunc("Store", "Purchase", "Credit Note", null, "Tab")?.editAccess


    useEffect(() => {
        getCreditNotesData()
        if (location.states?.success_message) {
            successMessage(location.states?.success_message)
            history.push({ states: {...location?.states, success_message : "" } })
        }
    }, [])

    const getCreditNotesData = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.STORE_CREDIT_NOTE)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setcreidtNoteData(response.data.data || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const errorMessage = (msg) => {
        setDisbleBtn(false)
        seterrorMsg(true)
        seterrorMsgText(msg)
    }
    const successMessage = (msg) => {
        setsuccessMsg(true)
        setsuccessMsgText(msg)
    }

    const GetPrint = () => {
        try {
            RestAPIService.getAllPrint(Serviceurls.STORE_CREDIT_NOTE + `?export_type=pdf`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const tableView = () => {
        try {
            const gridToolBar = () => {
                return (
                    <Box>
                        <CommonGridToolBarWithFilterText />
                    </Box>
                )
            }

            creditNoteData?.forEach((element, index) => element.sno = index + 1)
            const columns = [
                {
                    field: 'sno', headerName: 'S.No', flex: 0.05,
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.sno || '-'}</Box>)

                },
                {
                    field: 'vendor_name', headerName: 'Vendor Name', flex: 0.35, type: 'string',
                    renderCell: (params) => (params.row.vendor_name ? params.row.vendor_name?.length > 45 ?
                        <Tooltip placement="top" title={params.row.vendor_name}><Typography fontSize={'0.9vw'}>{params.row.vendor_name?.slice(0, 45) + '...'}</Typography></Tooltip> :
                        <Typography fontSize={'0.9vw'}>{params.row.vendor_name || '-'}</Typography> : '-')
                },
                {
                    field: 'credit_number', headerName: 'Credit No', flex: 0.15,
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.credit_number || '-'}</Box>)

                },
                {
                    field: 'credit_date', headerName: 'Credit Date', flex: 0.15, headerAlign: "center", align: "center",
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.credit_date || '-'}</Box>)

                },
                {
                    field: 'no_of_items', headerName: 'No of items', flex: 0.10, type: 'number',
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.no_of_items || '-'}</Box>)

                },
                {
                    field: "total_amount", flex: 0.14, headerName: "Credit Value" + ` (${CurrencySymbol})`, type: "number",
                    renderCell: (params) => (<Box component={'div'}>{AmountFormat((+params?.row?.total_amount + (params?.row?.paisa_amount / 100)).toFixed(2) || 0)}</Box>)

                },
                {
                    field: 'action', headerName: 'Action', flex: 0.10, headerAlign: "center", align: "center",
                    renderCell: (params) => (
                        <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                            <Tooltip title={"View Product"} placement="top" arrow>
                                <IconButton emed_tid={'st_view_' + params?.id} className='eMed_usrconf_btn' onClick={() => { history.push({ pathname: "/StorePurchase/CreditNote/Add", states: { credit_note_data: params?.row } }) }}>
                                    <img src={ImagePaths.LabEditButton.default} alt="View" style={{ width: '1.5vw', height: '1.5vw' }} />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    )

                },
            ];
            return (
                <Box sx={{ height: '70vh', marginTop: '.5vw', backgroundColor: 'white' }}>
                    <DataGrid
                        rows={creditNoteData}
                        columns={columns}
                        getRowId={(row) => row['sno']}
                        page={page}
                        pageSize={pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: gridToolBar,
                            NoRowsOverlay: () => (
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                    {'No Records To Be Shown'}
                                </Box>
                            )
                        }}
                        onPageChange={(newPage) => { setpage(newPage) }}
                        onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        density='standard'
                        disableSelectionOnClick
                        loading={isloader}
                    />
                </Box>
            )
        } catch (e) {

        }
    }

    return (
        <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box display={'flex'} justifyContent={'flex-end'} flexDirection={'row'} alignItems={'center'}>
                <Button disabled={!EditAccess} size="small" variant="contained" sx={{ textTransform: 'capitalize', width: '10vw' }} onClick={() => { history.push({ pathname: "/StorePurchase/CreditNote/Add" }) }}>{`Credit Note`}</Button>
                {/* <Tooltip title={'Filter'} placement="top">
                    <IconButton >
                        <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.Filter.default} alt='filter' />
                    </IconButton>
                </Tooltip> */}
                <Tooltip title={'Print'} placement="top">
                    <IconButton onClick={() => { GetPrint() }}          >
                        <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.LabPrintIcon.default} alt='filter' />
                    </IconButton>
                </Tooltip>
            </Box>
            <Box>
                {tableView()}
            </Box>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
        </Box>
    );
};

export default StoreCreditNote;
